const initAdvent = () => {
   const advent = document.querySelector(".advent");
   if (!advent) return;

   const adventLinks = advent.querySelectorAll(".advent__item a");
   const now = Date.now();

   adventLinks.forEach((link) => {
      const linkDate = new Date(link.dataset.date).getTime();

      if (now > linkDate) {
         link.removeAttribute("disabled");

         if (link.dataset.file) {
            link.setAttribute("href", link.dataset.file);
         } 
      };
   });
}

export default initAdvent;